export default __webpack_public_path__ + "static/media/val2.ef19675d.png";